module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    staticClass: "chartjs",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a602de2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-chartjs/src/Chartjs.vue
// module id = 419
// module chunks = 40